import { MijnRoute } from '../../mijn-navigatie.model';

export const COLLECTION_REFUND: MijnRoute = {
    path: 'incasso-terugboeken',
    navigationEvent: 'toIncassoRefund',
    regex: /^\/incasso\/incasso-terugboeken$/,
    webcomponent: 'mijn-transacties-incasso-webcomponent',
    internalPath: '/incasso-terugboeken'
};
